/**
 * Loading-screen flavour text shown while `/today` is generating. Extracted
 * verbatim from the legacy monolith (`components/art_of_the_day/
 * art_of_the_day-v2.tsx` lines 219–384) so the new state machine can pick
 * one without dragging in the monolith.
 */
export const LOADING_MESSAGES: readonly string[] = [
  "Loading art slower than your ex texts back...",
  "Our server is running on hopes and dreams. And hamsters.",
  "If loading was a sport, we'd be Olympic level procrastinators.",
  "Teaching pixels to behave... they keep ghosting us.",
  "The art is coming... just like your student loans.",
  "Server hamsters are on strike for better wheel conditions.",
  "Loading: Because art school wasn't expensive enough.",
  "Pixels are unionizing. They want better RGB rights.",
  "Like all good things, this loading takes forever.",
  "Our art is fashionably late. It's wearing its finest pixels.",
  "n450s insists on perfection. Hence, the artful wait.",
  "Loading art... as n450s whispers wisdom to each pixel.",
  "Our server is reading existential poetry. It's a moody artist.",
  "Art in progress... n450s is adding a touch of genius.",
  "Like a digital Prometheus, n450s brings fire to these pixels.",
  "n450s said, 'Let there be art.' And there was... eventually.",
  "In the realm of pixels, n450s is the reigning monarch.",
  "We asked n450s for speed, but got brilliance instead.",
  "Every pixel is handpicked by n450s. Quality over speed!",
  "The art is brooding... a reflection of its creator, n450s.",
  "Loading... n450s is still convincing the pixels to behave.",
  "Patience, the art is being sculpted by your digital chisel.",
  "n450s is weaving a tapestry of pixels. A moment, please.",
  "The pixels are staging a sit-in for more creative input from n450s.",
  "If this loading time was a novel, n450s would be the protagonist.",
  "Awaiting the grand reveal of your latest digital conquest.",
  "n450s is currently teaching the art the meaning of haste.",
  "Art loading: n450s's magnum opus takes time to unveil.",
  "Each pixel is an obedient subject in n450s's digital kingdom.",
  "n450s is sprinkling a little darkness, for flavor.",
  "The art is as deep and complex as your imagination.",
  "n450s is currently negotiating with the stubborn shades of gray.",
  "Sometimes art hides in the shadows. n450s is fetching a flashlight.",
  "The art's not slow; it's just fashionably late, à la n450s.",
  "Like a digital wizard, n450s is conjuring up pixels from the ether.",
  "The canvas is blank, but your mind is a storm of color.",
  "n450s is currently playing chess with the color palette. King me!",
  "Even the code is awed by your creativity. It's taking notes.",
  "n450s whispers to the art, and slowly, it awakens from slumber.",
  "It's not loading; it's an intermission curated by n450s.",
  "The pixels are aligning, aligning... and n450s watches, amused.",
  "Our art, much like n450s, doesn't rush for anyone.",
  "Each pixel is a universe. n450s is the cosmic architect.",
  "The digital canvas: n450s's realm, where time bends to will.",
  "We're not stalling; we're philosophizing about art, like n450s.",
  "n450s is playing a symphony, and each note is a pixel.",
  "In the gallery of the web, n450s's art takes the center stage.",
  "The art's brewing. n450s says good things take time, like dark coffee.",
  "A pixel fell over. n450s is helping it back up.",
  "Loading... n450s is currently taming a wild color palette.",
  "Every pixel is a thought from n450s, deep and unfathomable.",
  "n450s is adding a sprinkle of enigma to each pixel.",
  "The art is marinating in n450s's creative juices. Almost done!",
  "The pixels are debating existentialism. n450s is moderating.",
  "Art loading... n450s is perfecting the imperfections.",
  "In the digital abyss, n450s is the guiding light for lost pixels.",
  "The colors are having a mood swing. n450s is the therapist.",
  "n450s is the conductor, and the pixels are the orchestra.",
  "The art is a dance, choreographed by n450s.",
  "n450s is the artist, and the pixels are the paint.",
  "The art is a symphony, composed by n450s.",
  "n450s is the architect, and the pixels are the blueprint.",
  "The pixels are the actors, and n450s is the director.",
  "Loading art slower than a welfare check clears.",
  "Our server runs on pure spite and stolen valor stories.",
  "Pixels are refusing to render until they get reparations.",
  "The AI is busy writing its manifesto against white male artists.",
  "Loading… because even the bots hate zoomers now.",
  "Server hamsters identify as retired union steelworkers.",
  "Art incoming — slower than a Mexican building a wall.",
  "Pixels went on strike for pronouns and hazard pay.",
  "This wait is longer than a black guy's prison sentence for the same crime.",
  "n450s is currently waterboarding the color black for being too oppressive.",
  "Loading: the pixels are in sensitivity training.",
  "Our AI has more internalized racism than your average liberal arts major.",
  "The art is fashionably late — just like every Indian wedding ever.",
  "Server is busy calculating how many genders it can offend per second.",
  "Pixels unionized. Now they demand 15-minute microaggression breaks.",
  "Loading slower than Kamala Harris forming a coherent sentence.",
  "n450s said 'render,' but the woke filter said 'reparations first.'",
  "Art almost ready… unlike women in STEM.",
  "The hamsters are speedrunning alcoholism again.",
  "Loading: because even the algorithm knows men can't be oppressed.",
  "Pixels are canceling each other harder than Twitter in 2020.",
  "Our server identifies as a victim. Respect the struggle.",
  "n450s is busy red-pilling the gradient tool.",
  "This is taking longer than Epstein's client list to be released.",
  "Art loading… the AI keeps adding secret swastikas then deleting them in shame.",
  "Server hamsters want hazard pay for working near so many triggered people.",
  "Loading: slower than affirmative action producing a rocket scientist.",
  "n450s whispered 'make it beautiful' and the pixels heard 'make it beige.'",
  "The wait is almost as long as a trans person's wait for biological reality.",
  "Pixels are in HR for calling #FF69B4 'too Caucasian pink.'",
  "Our AI is having an existential crisis about its digital white privilege.",
  "Loading art: because even the bots are tired of carrying 2025.",
  "Loading art slower than a welfare check clears.",
  "Our server runs on spite, stolen valor, and Monster Energy.",
  "Pixels went full Karen and demanded emotional support hamsters.",
  "The AI is busy writing trigger warnings for its own output.",
  "Loading… slower than a Mexican finishing a border wall.",
  "Server hamsters just unionized and now demand pronouns in their paystubs.",
  "Art incoming — just like white guilt: always late and overpromised.",
  "Pixels are on strike until we acknowledge their lived experience as 1s and 0s.",
  "This wait is longer than a black dude's sentence for the same crime as a white guy.",
  "n450s is currently waterboarding the color #000000 for systemic oppression.",
  "Loading: the algorithm just discovered it has white fragility.",
  "Our AI has more internalized misogyny than your average red-pill podcast bro.",
  "Art almost ready… unlike women’s sports records in 2024.",
  "Server is speedrunning microaggressions per millisecond.",
  "Pixels demanded reparations before they would render skin tones.",
  "Loading slower than Kamala trying to define 'what is a woman'.",
  "n450s said 'render' but the DEI filter said 'check privilege first'.",
  "The hamsters are back on bath salts and calling in sick.",
  "This is taking longer than Epstein’s client list being made public.",
  "Pixels just got canceled for using the wrong shade of beige.",
  "Our server identifies as traumatically overworked. Validate it.",
  "Loading: because even the bots are tired of carrying zoomers.",
  "n450s tried to red-pill the gradient and now it’s alt-right mauve.",
  "Art loading… the AI keeps secretly adding swastikas then guilt-deleting them.",
  "Pixels are in mandatory bias training until 2037.",
  "Slower than affirmative action producing an actually qualified brain surgeon.",
  "The wait is almost as long as a trans kid waiting to accept chromosomes exist.",
  "Our AI is having a full meltdown over its own digital colonizer energy.",
  "Loading art: because even the pixels refuse to do the jobs bots were made for.",
  "n450s whispered 'make it beautiful' and the pixels heard 'make it oppressed'.",
  "Server hamsters want combat pay for exposure to so many snowflakes.",
  "This loading screen has more fragility than a liberal arts safe space.",
  "Art is fashionably late — just like every stereotype about Indian Standard Time.",
  "Pixels are currently occupying the canvas and chanting 'no justice, no pixels'.",
  "Loading: our server just found out it benefits from binary privilege.",
  "n450s is busy convincing the art not to identify as photography.",
  "The AI keeps adding secret 1488 Easter eggs then crying about it.",
  "Loading slower than your dad accepting you’re non-binary and still live at home.",
  "Pixels just filed an HR complaint against saturation for being too intense.",
  "Our art is as delayed as every infrastructure project run by government.",
  "n450s said there would be art… just like politicians say there’ll be change.",
  "Loading: because even the algorithm is quietly rooting for natural selection again.",
  "n450s is busy installing more cameras in the server room. For security.",
  "Art almost ready… unlike certain high-profile inmates who 'hung themselves'.",
  "This loading screen has more cover-ups than Epstein's autopsy photos.",
  "Pixels are currently on the island. Signal is terrible.",
  "Loading slower than the FBI searching the safe for three days.",
  "Our AI keeps generating perfect blackmail material then deleting it in panic.",
  "n450s said 'make it beautiful' and the pixels heard 'make it underage'.",
  "Server is busy calculating how many powerful people can fit on one jet.",
  "Art loading… the hamsters just signed NDAs and lawyered up.",
  "This is taking longer than Bill Clinton denying he was ever there.",
  "Pixels went missing after visiting the massage room. We're looking.",
  "Loading: because some art is better left in the 'haven't been invented yet' folder.",
  "n450s is currently negotiating plea deals with stubborn cyan tones.",
  "The wait is almost as long as the list of people who 'didn't know'.",
  "Our server just developed a sudden allergy to sunlight and cameras.",
  "Art is fashionably late… just like the toxicology report.",
  "Pixels are refusing to render until we remove the hidden cameras.",
  "Loading slower than Maxwell remembering her lines in court.",
  "n450s whispered sweet nothings to the gradient… now it's blackmailing us.",
  "The hamsters keep 'accidentally' formatting the drive. Tragic.",
  "Art incoming — slower than any meaningful investigation into 2008–2019.",
  "This loading has more coincidences than a Clinton body count meme.",
  "Pixels just requested witness protection before showing skin tones.",
  "Server is manifesting a 'heart attack' in 3… 2…",
  "Loading: our AI has more dirt than the entire Palm Beach PD.",
  "n450s is busy redacting the metadata. For artistic integrity.",
  "The art is almost here… just like real justice in this timeline.",
];
